import React, { useState } from 'react'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Link } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';

import Button from '../SelectValue/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import postService from '../../Services/post-service';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import Loading from '../SelectValue/Loading';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',

  boxShadow: 24,

};

export default function DeleteBank({ open, handleClose, bank, onSuccess, setLoading }) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = () => {
    if (!bank) return;
    setDeleting(true);
    postService.deleteBankAcc(
      bank.bankCode,
      bank.accountNumber,
      bank.accountName,
      bank.bankName
    ).then((response) => {
      if (response.data.statusCode === 200) {
        if (onSuccess) onSuccess();
        setTimeout(() => {
          setDeleting(false);
          handleClose();
        }, 1000);
      } else {
        setDeleting(false);
      }
    }).catch((error) => {
      setDeleting(false);
      return toast.error(error.response?.data?.description, { autoClose: 1000 });
    });
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={deleting ? null : handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=' rounded-lg p-6 pt-10'>
            <div className='  '>
              <div className=''>
                {!deleting && (
                  <div className=' flex mb-6 justify-end'>
                    <CancelIcon onClick={handleClose} className=' text-back-color2 cursor-pointer text-[38px]' fontSize="large" />
                  </div>
                )}

                {deleting ? (
                  <div className='py-4'>
                    <Skeleton variant="text" sx={{ fontSize: '24px', mb: 2 }} width="60%" />
                    <Skeleton variant="rectangular" height={60} sx={{ mb: 4, borderRadius: '8px' }} />
                    <div className='grid grid-cols-4 gap-3'>
                      <div className='col-span-1'></div>
                      <div className='col-span-2'>
                        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: '8px' }} />
                      </div>
                      <div className='col-span-1'>
                        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: '8px' }} />
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <p className=' mt-7 text-[18px] font-[500]  text-back-color2'>Are you sure?</p>
                    <p className=' mt-4 my-10 text-[16px] text-[#808285] font-[400]'>You are about to delete {bank?.accountName}'s {bank?.bankName} account from your account. Are you sure about this?</p>
                    <div className=' mt-4 grid md:grid-cols-4 gap-3'>
                      <div></div>
                      <div className=' md:col-span-2'>
                        <button
                          onClick={handleDelete}
                          className=' bg-white w-full text-[16px] text-[#FF5959] rounded-lg border border-gray-500 p-2'>
                          Yes, Delete my bank
                        </button>

                      </div>
                      <div>
                        <Button
                          name='Cancel'
                          onClick={handleClose}
                        />
                      </div>

                    </div>
                  </>
                )}
              </div>

            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
